import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ConfigPedidoModule } from '../../configuracoes/app/pedido';
import { UsuarioEmailAdministrativoSelectModule } from '../../usuario/email/administrativo/select';

import { PedidoEmailModalComponent } from './pedido-email-modal.component';

@NgModule({
    imports: [
        SharedModule,
        ConfigPedidoModule,
        UsuarioEmailAdministrativoSelectModule
    ],
    declarations: [
        PedidoEmailModalComponent
    ],
    exports: [
        PedidoEmailModalComponent
    ]
})
export class PedidoEmailModule { }
